import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';

import EmbeddedMediumImageLabelViewModelT from '@/ViewModels/Controls/EmbeddedMediumImageLabelViewModel';
import EmbeddedMediumImageLabelT from '@/Controls/EmbeddedMediumImageLabel';

export default class EmbeddedMediumImageLabelFactory extends ControlFactory {

    public override control: EmbeddedMediumImageLabelT;
    public override viewModel: EmbeddedMediumImageLabelViewModelT;

    public thumbWidth: number;
    public thumbHeight: number;

    private controlHtmlElement: JQuery;
    private technicalNameRootProperty = '';
    private technicalNameFilename = '';

    public constructor(private params: any) {
        super(params);

        this.thumbWidth = this.paramOrDefault(params.imageWidth, 0, (val: string, def: number) => parseInt(val) || def);
        this.thumbHeight = this.paramOrDefault(params.imageHeight, 0, (val: string, def: number) => parseInt(val) || def);
    }

    public getControl(): JQuery {
        if (this.controlHtmlElement != null) {
            return this.controlHtmlElement;
        }

        let EmbeddedMediumImageLabelViewModel = ComponentManager.getViewModel<typeof EmbeddedMediumImageLabelViewModelT>('EmbeddedMediumImageLabelViewModel');
        let EmbeddedMediumImageLabel = ComponentManager.getControl<typeof EmbeddedMediumImageLabelT>('EmbeddedMediumImageLabel');

        this.validateTechName();
        let filename = this.context.genericObject.getObservable(this.technicalNameFilename);

        this.viewModel = new EmbeddedMediumImageLabelViewModel({
            pdoId: this.context.genericObject.pdoId,
            lockGroupId: this.context.detailViewContextDTO.lockGroupID,
            attributeName: this.technicalNameRootProperty,
            showImage: this.defineComputed(() => {
                return !!filename();
            }),
            thumbWidth: this.thumbWidth,
            thumbHeight: this.thumbHeight,
            alternativeText: filename
        });
        this.control = new EmbeddedMediumImageLabel(this.viewModel as EmbeddedMediumImageLabelViewModelT);

        let tuple = this.control.getTuple();
        this.controlHtmlElement = tuple.control;

        return this.controlHtmlElement;
    }

    private validateTechName() {
        this.technicalNameRootProperty = this.detailViewItem.name;

        if (this.detailViewItem.name.substring(this.detailViewItem.name.length - 6) === '.Value') {
            this.technicalNameRootProperty = this.detailViewItem.name.substring(0, this.detailViewItem.name.length - 6);
        }

        this.technicalNameFilename = this.technicalNameRootProperty + '.Filename';

    }
}

ComponentManager.setFactory('EmbeddedMediumImageLabel', EmbeddedMediumImageLabelFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');